import { render } from "./EmployeeRequests.vue?vue&type=template&id=4fe5d682"
import script from "./EmployeeRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRequests.vue?vue&type=script&lang=js"

import "./EmployeeRequests.vue?vue&type=style&index=0&id=4fe5d682&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__